import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductsDataView, ProductsState } from "@insite/client-framework/Store/Data/Products/ProductsState";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { setDataViewLoaded } from "@store/Store/Data/DataState";
import { Draft } from "immer";

const initialState: ProductsState = {
    isLoading: {},
    idByPath: {},
    byId: {},
    dataViews: {},
};

const reducer = {
    "Data/Products/CompleteLoadProducts": (
        draft: Draft<ProductsState>,
        action: { parameter: object; collection: ProductCollectionModel },
    ) => {
        const { parameter, collection } = action;
        /* Valtech Custom Code - This is a copy of the "Data/Products/CompleteLoadProducts"
        from client-framework\src\Store\Data\Products\ProductsReducer.ts
        but it calls 'setDataViewLoaded' that is in our Store DataState instead. */
        setDataViewLoaded(
            draft,
            parameter,
            collection,
            collection => collection.products!,
            (product: ProductModel) => {
                draft.idByPath[product.canonicalUrl] = product.id;
            },
            (dataView: ProductsDataView) => {
                dataView.attributeTypeFacets = collection.attributeTypeFacets;
                dataView.brandFacets = collection.brandFacets;
                dataView.categoryFacets = collection.categoryFacets;
                dataView.correctedQuery = collection.correctedQuery;
                dataView.didYouMeanSuggestions = collection.didYouMeanSuggestions;
                dataView.exactMatch = collection.exactMatch;
                dataView.notAllProductsAllowed = collection.notAllProductsAllowed;
                dataView.notAllProductsFound = collection.notAllProductsFound;
                dataView.originalQuery = collection.originalQuery;
                dataView.priceRange = collection.priceRange;
                dataView.productLineFacets = collection.productLineFacets;
                dataView.searchTermRedirectUrl = collection.searchTermRedirectUrl;
            },
        );
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
